/**
 * Error class for user validation failures.
 * These errors should NOT be reported to Datadog as they are
 * expected user input errors, not system failures.
 *
 * Use this for:
 * - Missing required fields
 * - Invalid input formats
 * - Form validation failures
 *
 * Do NOT use this for:
 * - API errors
 * - Network failures
 * - System/infrastructure issues
 */
export class ValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ValidationError';
  }
}
